<template>
  <div>
    <v-tabs v-model="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{tab.title}}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "TransferTabs",
  data() {
    return {
    };
  },
  computed: {
    selectedTab(){
      if(this.$route.name == 'TransferForm') {
        return 0
      }
      if(this.$route.name == 'TransfersList') {
        return 1
      }
    },
    tabs() {
      return [
        {title: 'ثبت انتقال بین انبار', key: '/panel/transfer/form'},
        {title: 'لیست انتقال بین انبار', key: '/report/lists/transfers'},
      ]
    },
  },
  methods: {
    changeRoute(tab){
      this.$router.push(tab.key)
    }
  }

};
</script>

<style scoped lang="scss">
</style>

